import React, { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { DatadogProvider } from 'shared/datadog/DatadogProvider';
import { CableProvider } from '../shared/action-cable/CableProvider';
import { AppThemeProvider } from '../styleguide/theme';
import store from './store';

export const AppProviders: React.FC<PropsWithChildren> = ({ children }) => (
  <AppThemeProvider>
    <DatadogProvider>
      <BrowserRouter>
        <Provider store={store}>
          <CableProvider>{children}</CableProvider>
        </Provider>
      </BrowserRouter>
    </DatadogProvider>
  </AppThemeProvider>
);
